import { render, staticRenderFns } from "./RoomNav.vue?vue&type=template&id=32b2e8a7&scoped=true&"
import script from "./RoomNav.vue?vue&type=script&lang=js&"
export * from "./RoomNav.vue?vue&type=script&lang=js&"
import style0 from "./RoomNav.vue?vue&type=style&index=0&id=32b2e8a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b2e8a7",
  null
  
)

export default component.exports